import React, { Component } from 'react';

import './styles.scss';

class Header extends Component {
    render() {
        const HeaderType = this.props.type;

        return (
            <HeaderType className="header-component pt-2 pb-2">{this.props.children}</HeaderType>
        );
    }
}

export default Header;

Header.defaultProps = {
    type: 'h1'
}